import React from "react";
import { analysisBlocks } from "./analysisBlocks";

export const AnalysisText = ({ value, prefix }) => {
  const blocks = analysisBlocks(value, prefix);
  return <div className="space-y-3">{blocks.map(block => block.kind === "heading"
    ? <h3 key={block.id} className="text-sm font-medium capitalize pt-2" data-testid={block.id}>{block.text}</h3>
    : <p key={block.id} className="text-sm leading-relaxed whitespace-pre-line" data-testid={block.id}>{block.text}</p>)}</div>;
};